exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".move-abit {\r\n  padding-top: 30px;\r\n  padding-right: 100px;\r\n}\r\n.form161-not-allowed\r\n{\r\n  width: 100%;\r\n  height: 200px;\r\n  text-align: center;\r\n  font-size: 18px;\r\n  color: black;\r\n  font-weight: bold;\r\n  padding-top: 100px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/form161-forlmaly-list/form161-forlmaly-list.component.css
// module id = ../../../../../src/app/form161-forlmaly-list/form161-forlmaly-list.component.css
// module chunks = main